/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowTravelPlanTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowTravelPlan,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Plan Our Next Adventure!",
    "Travel Together Awaits!",
    "Where Should We Go?",
  ],
  title: "Travel Planning",
  description: "Organize a fun travel plan.",
  longDescription:
    "Gather your friends to plan your next adventure! Choose a date, decide on destinations, and plan activities to do while traveling!",
  emoji: "✈",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Travel Planning",
          emoji: "✈",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go on the trip?",
          emoji: "📅",
          completeAction: {
            question: "Decide on destinations?",
            description: "Where do we want to travel?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What destinations should we consider?",
                emoji: "🌍",
                completeAction: {
                  question: "Decide on activities to do?",
                  description: "What activities should we plan for the trip?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we include?",
                      emoji: "🏖",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Explore the World!",
    outroDescription: "Your travel plans are set! Enjoy the adventure!",
  },
};
